
import Store from "util/store"
import protocolSender from "util/protocol-sender"
import { MediaType, MediaOper, EventType, RecvState, DisplayMode, EventResult } from "common/enums"
import { tracelog, asyncWrapper, getEventPostfix, preloadImage } from 'common/common'
import { promiseHandler, hstRequest } from "common/promise-handler"
import logger from 'common/logger'
// import { getEventPostfix } from 'common/common.js'
// import ReadOnlyWhiteboard from "./readonly-white-board"
import Painter from 'whiteBoard/Painter'
import eventRegistry from "common/event-registry"
import UploaderManager  from './upload-manager'

/**
 * 管理所有白板对象
 */
class WhiteboardManager {
  constructor() {
    this._init();

    // 注册信令服务事件
    Store.msgDispatcher.addMsgHandler(19001, this._onCreateWhiteBoardRes.bind(this));
    Store.msgDispatcher.addMsgHandler(19003, this._onCloseWhiteBoardRes.bind(this));
    Store.msgDispatcher.addMsgHandler(20007, this._onGetWhiteBoardFileUrlRes.bind(this));
    
    return this;
  }

  /**
   * 尝试恢复白板的渲染
   * @param {*} mediaId
   * @returns 是否找到白板 
   */
  @tracelog
  tryRestoreWhiteBoardRender(mediaId) {
    if (this.restoreWhiteBoards.length == 0) {
      logger.log("Empty restore white boards.")
      return false;
    }

    let board = this.restoreWhiteBoards[0];
    if (board.mediaId != mediaId) {
      logger.log("Different white board.");
      return false;
    }

    this.setWhiteBoardRender(mediaId, board.parentEle);
    this.setDisplayMode(mediaId, board.displayMode, board.displayParam);

    this.restoreWhiteBoards.shift();
    if (this.restoreWhiteBoards.length > 0) {
      asyncWrapper(()=>{this._doStartReceiveWhiteBoard(this.restoreWhiteBoards[0])})
    }

    return true;
  }

  /**
   * 接收白板
   * @param {*} mediaId 
   */
  _doStartReceiveWhiteBoard(userId, mediaId) {
    this.startReceiveWhiteBoard(userId, mediaId).then(()=>{
      logger.log("Start receive white board success.");
    }).catch((e)=>{
      logger.error("Start receive white board failed, err: " + e);
      this.restoreWhiteBoards.shift();
    })
  }

  /**
   * 恢复白板事件处理
   * @param {*} params 
   */
  @tracelog
  restoreWhiteBoard(params) {
    // 先删除原来的白板对象
    this.removeWhiteBoard(params.mediaId)
    this.restoreWhiteBoards.push(params)
    if (this.restoreWhiteBoards.length == 1) {
      this._doStartReceiveWhiteBoard(params.userId, params.mediaId);
    }
  }

  /**
   * 初始化
   */
  _init() {
    // 包含本地创建和接收远端的白板
    Store.whiteBoards = this.whiteBoards = new Array();

    // 全局显示模式和参数
    this.displayMode = null;
    this.displayParam = null;

    // fileUrlMap
    this.cacheFileUrlMap = new Map()

    // 自动恢复白板
    this.restoreWhiteBoards = new Array();
  }

  /**
   * 创建白板
   */
  createWhiteBoard(params) {
    protocolSender.sendCreateWhiteboardReq(params);
    return promiseHandler(EventType.EVENT_CREATE_WHITE_BOARD);
  }
  
  /**
   * 创建白板响应
   * @param {*} params 
   */
  _onCreateWhiteBoardRes(params) {
    eventRegistry.trigger(
      EventType.EVENT_CREATE_WHITE_BOARD, 
      params.result == 0 ? EventResult.SUCCESS : EventResult.FAILED,  params.result == 0 ? params.board_id : null)
  }

  /**
   * 关闭白板
   * @param {*} mediaId 
   */
  closeWhiteBoard(mediaId) {
    if (!mediaId) {
      console.error("Invalid mediaId!");
      return;
    }
    protocolSender.sendCloseWhiteboardReq(mediaId)
    // 改变白板对象的状态 不触发自动重连
    // let whiteBoard = this._findWhiteBoard(mediaId)
    // whiteBoard.close()

    return promiseHandler(EventType.EVENT_CLOSE_WHITE_BOARD);
  }

  /**
   * 关闭白板响应
   * @param {*} params 
   */
  _onCloseWhiteBoardRes(params) {
    eventRegistry.trigger(
      EventType.EVENT_CLOSE_WHITE_BOARD, 
      params.result == 0 ? EventResult.SUCCESS : EventResult.FAILED)
  }

  /**
   * 开始广播白板
   * @param {*} mediaId 
   */
  startPublishWhiteBoard(mediaId) {
    protocolSender.sendPublishMediaReq(MediaOper.START_PUBLISH, MediaType.WHITE_BOARD, mediaId);
    
    // 发布响应（暂未实现）
    // return promiseHandler(EventType.EVENT_START_PUB_WHITE_BOARD);
  }

  /**
   * 停止广播白板
   * @param {*} mediaId 
   */
  stopPublishWhiteBoard(mediaId) {
    protocolSender.sendPublishMediaReq(MediaOper.STOP_PUBLISH, MediaType.WHITE_BOARD, mediaId);
    // 发布响应（暂未实现）
    // return promiseHandler(EventType.EVENT_STOP_PUB_WHITE_BOARD);
  }

  /**
   * 开始接收白板
   * @param {*} userId 
   * @param {*} mediaId 
   */
  startReceiveWhiteBoard(userId, mediaId) {
    return hstRequest.request({
      eventName: EventType.EVENT_START_RCV_MEDIA + getEventPostfix(userId, MediaType.WHITE_BOARD, mediaId),
      retryConfig: {
        num: 0,
        max: 4
      },
      requestFn: () => {
        protocolSender.sendRecvMediaReq(
          RecvState.START_RECV, 
          userId, 
          MediaType.WHITE_BOARD, 
          mediaId);
      }
    })
    protocolSender.sendRecvMediaReq(
      RecvState.START_RECV, 
      userId, 
      MediaType.WHITE_BOARD, 
      mediaId);

    // 可能同时接收多个视频，保证请求和响应匹配
    return promiseHandler(EventType.EVENT_START_RCV_MEDIA + getEventPostfix(userId, MediaType.WHITE_BOARD, mediaId));
  }

  /**
   * 停止接收白板
   * @param {*} userId 
   * @param {*} mediaId 
   */
  stopReceiveWhiteBoard(userId, mediaId) {
    protocolSender.sendRecvMediaReq(
      RecvState.STOP_RECV, 
      userId, 
      MediaType.WHITE_BOARD, 
      mediaId);

    return promiseHandler(EventType.EVENT_STOP_RCV_MEDIA + getEventPostfix(userId, MediaType.WHITE_BOARD, mediaId));
  }

  /**
   * 设置白板渲染器
   * @param {*} mediaId 
   * @param {*} parentEle 
   */
  setWhiteBoardRender(mediaId, parentEle) {
    if (!parentEle) {
      logger.warn("Invalid parent element for canvas!");
      return;
    }

    for (let board of this.whiteBoards) {
      if (board.mediaId == mediaId) {
        board.setParentElement(parentEle);
      }
    }
  }

  /**
   * 取消设置白板渲染器
   * @param {*} userId 
   * @param {*} mediaId
   */
  unsetWhiteBoardRender(userId, mediaId) {
    if (mediaId instanceof HTMLElement) {
      mediaId.innerHTML = ''
    } else {
      for (let board of this.whiteBoards) {
        if (board.mediaId == mediaId) {
          board.setParentElement(null);
        }
      }
    }
  }

  /**
   * 设置显示模式
   * @param {*} mediaId 
   * @param {*} mode 
   * @param {*} param 
   */
  @tracelog
  setDisplayMode(mediaId, mode, param) {
    if (mode != DisplayMode.DBWZ 
      && mode != DisplayMode.DBSY 
      && mode != DisplayMode.DBSF) {
      logger.error("Invalid display mode: " + mode);
      return;
    }

    if (mode == DisplayMode.DBSF) { 
      if (!param) {
        logger.error("setDisplayMode param is invalid!");
        return;
      } else {
        if (!Number.isInteger(param)) {
          logger.error("setDisplayMode param should be integer!");
          return;
        }
      }
    }

    if (!mediaId) { // 全局设置
      for (const board of this.whiteBoards) {
        board.setDisplayMode(mode, param);
      }
      this.displayMode = mode;
      this.displayParam = param;
    } else { // 单独设置
      let board = this._findWhiteBoard(mediaId);
      if (board) {
        board.setDisplayMode(mode, param);
      } else {
        logger.error("Cannot find white board " + mediaId);
      }
    }
  }
  
  /**
   * 收到开始接收白板的响应
   * @param {*} params 
   */
  onStartRecvWhiteBoardRes(params) {
    if (this._findWhiteBoard(params.mediaId)) {
      logger.error("White baord " + params.mediaId + "exists already!");
    } else {
      let board = new Painter(params);
      this.whiteBoards.push(board);
      if (this.displayMode) { // 默认使用全局设置
        board.setDisplayMode(this.displayMode, this.displayParam);
      }
    }
  }

  /**
   * 收到停止接收白板的响应
   * @param {*} params 
   */
  onStopRecvWhiteBoardRes(params) {
    let board = this._findWhiteBoard(params.mediaId);
    if (board) {
      this.removeWhiteBoard(params.mediaId)
      board.close()
      const path  = board.pageStore && board.pageStore.getConvertFilePath()
      this.cacheFileUrlMap.delete(path)
    } else {
      logger.error("Cannot find White baord " + params.mediaId);
    }
  }



  /**
   * 重新初始化
   */
  reinitialize() {
    for (const board of this.whiteBoards) {
      board.close();
    }
    this._init();
  }

  /**
   * 移除指定白板
   * @param {*} mediaId 
   */
  removeWhiteBoard(mediaId) {
    this.whiteBoards.forEach(function(board, index, arr) {
      if (board.mediaId == mediaId) {
        arr.splice(index, 1);
        return false;
      }
    })
  }

  /**
   * 获取指定白板
   * @param {*} mediaId 
   */
  getWhiteBoard(mediaId) {
    return this._findWhiteBoard(mediaId)
  }
  /**
   * 
   * @param {*} mediaId 
   */
  startUploadDoc (params) {
    let uploader = new UploaderManager(params)
    uploader.startUpload()
  }
  /**
   * 查找白板
   * @param {*} mediaId 
   */
  _findWhiteBoard(mediaId) {
    for (const board of this.whiteBoards) {
      if (board.mediaId == mediaId) {
        return board;
      }
    }
    return null;
  }

  /**
   * 获取白板图片响应
   * @param {*} data 
   */
  _onGetWhiteBoardFileUrlRes(data) {
    if (data.code === 0) {
      let filePath = data.data.file_path
      const rootPath = filePath.substr(0, filePath.lastIndexOf('/'))
      let fileUrls = this.cacheFileUrlMap.get(rootPath) || new Map()
      fileUrls.set(data.data.file_path, data.data.url)
      this.cacheFileUrlMap.set(rootPath, fileUrls)
      preloadImage(data.data.url, () => {})
      eventRegistry.trigger(EventType.EVENT_GET_IMG_URL, EventResult.SUCCESS)
    } else {
      eventRegistry.trigger(EventType.EVENT_GET_IMG_URL, EventResult.FAILED)
    }
  
  }

  /**
   * 
   * @param {*} file_path
   */
  _getFileUrl (file_path) {
    protocolSender.sendGetWhiteBoardFileUrlReq(file_path);
    return promiseHandler(EventType.EVENT_GET_IMG_URL)
  }
}

export default new WhiteboardManager();